import React from 'react';
export const SymptomsSection = () => {
  return <section id="symptoms" className="w-full py-12 bg-green-900/10" data-id="element-273">
      <div className="container mx-auto px-4" data-id="element-274">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-8 text-center" data-id="element-275">
          What Are The Signs Of Poor Gut Health?
        </h2>
        <p className="text-green-900/80 mb-8 text-center max-w-3xl mx-auto" data-id="element-276">
          Most dog owners don't realize their pet's various health issues all
          stem from the same source. Here are the signs of an imbalanced gut:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-277">
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-278">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-279">
              Digestive Issues:
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-280">
              <li data-id="element-281">• Irregular bowel movements</li>
              <li data-id="element-282">• Excessive gas</li>
              <li data-id="element-283">• Gurgling stomach sounds</li>
              <li data-id="element-284">• Inconsistent appetite</li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-285">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-286">
              Skin & Coat Problems:
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-287">
              <li data-id="element-288">• Constant itching or scratching</li>
              <li data-id="element-289">• Red, inflamed skin</li>
              <li data-id="element-290">• Dull, oily coat</li>
              <li data-id="element-291">• "Doggy" smell that won't go away</li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-292">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-293">
              Energy & Mobility Issues:
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-294">
              <li data-id="element-295">• Acting "older" than their years</li>
              <li data-id="element-296">• Stiff movements, especially in the morning</li>
              <li data-id="element-297">• Less interest in play or walks</li>
              <li data-id="element-298">• Difficulty getting up</li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-299">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-300">
              Immune System Weakness:
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-301">
              <li data-id="element-302">• Frequent ear infections</li>
              <li data-id="element-303">• Seasonal allergies getting worse</li>
              <li data-id="element-304">• Slow healing</li>
              <li data-id="element-305">• Bad breath that won't improve</li>
            </ul>
          </div>
        </div>
        <p className="text-green-900 mb-8 text-center font-bold text-lg" data-id="element-306">
          If your dog shows even ONE of these signs, their gut health needs
          attention.
        </p>
        <div className="flex justify-center" data-id="element-307">
          <a href="#product" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-308">
            CHECK YOUR DOG'S SYMPTOMS
          </a>
        </div>
      </div>
    </section>;
};